// extracted by mini-css-extract-plugin
export default {"material-card":"StudyMaterial_material-card__VaivS","text-primary":"StudyMaterial_text-primary__HIRpf","button-primary":"StudyMaterial_button-primary__gUR8y"};